import { getWebEnvObj } from "@/utils";
import Cookies from "js-cookie";
/**
 * 本地存储对象，目前仅使用localStorage存储
 */
class LocalCache {
  setItem = (key: string, value: string) => {
    if (!window || !window.localStorage) {
      return false;
    }
    window.localStorage.setItem(key, value);
    return true;
  };
  getItem = (key: string) => {
    if (!window || !window.localStorage) {
      return false;
    }
    return window.localStorage.getItem(key);
  };
  removeItem = (key: string) => {
    if (!window || !window.localStorage) {
      return false;
    }
    window.localStorage.removeItem(key);
    return true;
  };
}
export default new LocalCache();


 export const clearCookies = () => {

  const { REACT_APP_TOP_LEVEL_DOMAIN, REACT_APP_ROUTE_BASE } = getWebEnvObj();

  Cookies.remove("focus-token", {
    domain: REACT_APP_TOP_LEVEL_DOMAIN,
    path: REACT_APP_ROUTE_BASE || "/client"
  });
  // 增加由服务端setCookies设置的cookie信息
  Cookies.remove("focus-token", {
    domain: REACT_APP_TOP_LEVEL_DOMAIN,
    path: "/"
  });
  Cookies.remove("focus-app-id", {
    domain: REACT_APP_TOP_LEVEL_DOMAIN,
    path: REACT_APP_ROUTE_BASE || "/client"
  });
  Cookies.remove("focus-app-id", {
    domain: REACT_APP_TOP_LEVEL_DOMAIN,
    path: "/"
  });
  Cookies.remove("focus-team-id", {
    domain: REACT_APP_TOP_LEVEL_DOMAIN,
    path: REACT_APP_ROUTE_BASE || "/client"
  });
  Cookies.remove("focus-team-id", {
    domain: REACT_APP_TOP_LEVEL_DOMAIN,
    path: "/"
  });
}